// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from '@/App';
import router from '@/router';
import VueResource from 'vue-resource';
import store from '@/store';
import auth from '@/api/auth';
import i18n from '@/i18n';
import VueMq from 'vue-mq';
import Tooltip from 'v-tooltip';
import VueChannelColorPicker from 'vue-channel-color-picker';
import directives from '@/directives';
import VueAnalytics from 'vue-analytics';
import config from 'BRAND/config';

// Google maps
import * as VueGoogleMaps from 'vue2-google-maps';
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDDkWvkCOzdYwHb2Op5ifvlZiLAnOP4X9Q',
    libraries: 'places'
  }
});

// Google Analytics
if (config.trackingCode) {
  Vue.use(VueAnalytics, {
    id: config.trackingCode
  });
}

// Vuew Mq
Vue.use(VueMq, {
  breakpoints: {
    // xs: 359,
    // s: 449,
    // m: 649,
    breakpoint: 800,
    // xl: 1099,
    // xxl: 1299,
    wide: Infinity
  }
});

// Tooltip
Vue.use(Tooltip);

// ColorPicker
Vue.use(VueChannelColorPicker);

// Resources
Vue.use(VueResource);

// Http interceptors
const loadingInterceptor = (request, next) => {
  const timestamp = new Date().getTime();
  const interval = setInterval(function () {
    clearInterval(interval);
    store.dispatch('addRequest', timestamp);
  }, 500);

  next((response) => {
    clearInterval(interval);
    store.dispatch('removeRequest', timestamp);
  });
};

Vue.http.interceptors.push(loadingInterceptor);
Vue.http.interceptors.push(auth.tokenInterceptor);
Vue.http.interceptors.push(auth.loginInterceptor);

// Prevent the production tip on Vue startup
Vue.config.productionTip = false;

// Event bus
export const eventBus = new Vue();

// Directives
Vue.directive('has-route', directives.hasRoute(router));
Vue.directive('has-any-route', directives.hasAnyRoute(router));
Vue.directive('has-feature', directives.hasFeature(store));
Vue.directive('has-any-feature', directives.hasAnyFeature(store));

// Root component
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: router,
  store: store,
  i18n: i18n.config,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js